<template>
    <div class="person-right">
        <div class="maintop">
            <span>合同详情</span>
        </div>
        <el-divider></el-divider>
        <el-form
            style="width:100%;padding:35px 0 14px 0"
            label-width="150px"
            size="small"
            :model="contractInfo"
        >
        <el-row class="linetwo">
            <el-col :span="10">
                <el-form-item label="合同编号：">
                    {{contractInfo.contractNo}}
                </el-form-item>
            </el-col>            
            <el-col :span="10">
                <el-form-item label="合同状态：">
                    <span :class="contractInfo.contractStatus==2?'blue':''">{{contractInfo.contractStatusName}}</span>                    
                </el-form-item>
            </el-col>
        </el-row>
        <el-row class="linetwo">
            <el-col :span="10">
                <el-form-item label="租赁小区：">
                    {{contractInfo.communityName}}
                </el-form-item>
            </el-col>
            <el-col :span="10">
                <el-form-item label="单位名称：">
                    {{contractInfo.companyName}}
                </el-form-item>
            </el-col>
        </el-row>
        <el-row class="linetwo">
            <el-col :span="10">
                <el-form-item label="租赁位置：">
                    {{contractInfo.roomAddress}}
                </el-form-item>
            </el-col>
            <el-col :span="10">
                <el-form-item label="合同总期数：">
                    {{contractInfo.terms}}(期)
                </el-form-item>
            </el-col>
        </el-row>
            <el-row class="linetwo">
                <el-col :span="10">
                    <el-form-item label="合同开始日期：">
                        {{contractInfo.beginDate}}
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="合同结束日期：">
                        {{contractInfo.endDate}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="linetwo">
                <el-col :span="10">
                    <el-form-item label="缴费周期：">
                        {{contractInfo.payedRange}}
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="租金支付方式：">
                        {{contractInfo.payedType}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="linetwo">
                <el-col :span="10">
                    <el-form-item label="付费方式：">
                        {{contractInfo.payedParty}}
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="合同类型：">
                        {{contractInfo.contractKindName}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="linetwo">
                <el-col :span="10">
                    <el-form-item label="签约保证金：">
                        {{contractInfo.deposit}}(元)
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="每月租金：">
                        {{contractInfo.rental}}(元)
                        {{contractInfo.isApplyTalent ? "（人才价）" : ""}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="linetwo">
                <el-col :span="10">
                    <el-form-item label="是否为过渡期合同：">
                        {{contractInfo.isTransitionalContract ? "是" : "否"}}
                    </el-form-item>
                </el-col>
                <el-col :span="10" v-if="contractInfo.isTransitionalContract">
                    <el-form-item label="过渡期类型：">
                        {{contractInfo.transitionalContractType}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20" align="center">
                    <el-button style="margin:0 45%;" type="primary" @click="goPrevious">返回</el-button>
                </el-col>
            </el-row>
        </el-form>       
        
    </div>
</template>

<script>
import UserApi from "@/api/user/index";
let moment = require("moment")
export default {
    data(){
        return{
            contractInfo:{},
        }
    },
    methods:{
        getContractDetail (id) {
            UserApi.getContractDetail(id)
                .then(
                    (res) => {
                        this.contractInfo=res.data
                        this.contractInfo.beginDate = moment(this.contractInfo.beginDate).format('YYYY-MM-DD')
                        this.contractInfo.endDate = moment(this.contractInfo.endDate).format('YYYY-MM-DD')
                    },
                    (err) => {
                        this.$message({
                        message: err,
                        center: true,
                        });
                    }
                )
                .catch((error) => {
                    this.$message({
                        message: error,
                        center: true,
                });
            }); 
        },
        goPrevious(){
            this.$router.go(-1)
        }
    },
    activated(){
        this.getContractDetail(this.$route.query.id)
    }
}
</script>

<style scoped>
.el-divider{
    margin: 0;
}
.norsamll{
    width: 50%;
}
.linetwo>>>.el-form-item.el-form-item--small{
    width:94.4%
}

.blue{
    color: #157BE9;
}
</style>